// extracted by mini-css-extract-plugin
export default {"container":"AdminEditProgramDetails_container__MGxlg","content":"AdminEditProgramDetails_content__-Qb63"};